<template>
  <div :class="showTitle ? 'mt-4' : ''">
    <div>
      <h2 :class="textColorClass" class="pl-3 text-zt-xl pb-3" v-if="showTitle">
        {{ $t("message.LicensesHistoryComponent.tabs.licensesForApproval.historyLicenses") }}
      </h2>
      <div>
        <template v-if="loading">
          <div class="py-20">
            <vue-loading
              background-color="rgba(0,0,0,0.0)"
              :color="primaryLoadingColor"
              :width="100"
              :height="100"
              :is-full-page="false"
              :active="loading"
            />
          </div>
        </template>
        <template v-else>
          <template v-if="history.length > 0">
            <zt-list-item
              v-for="(item, index) in history"
              :key="index"
              :to="{name: 'requestDetail', params: {'license': item}}"
              class="mt-1"
            >
              <template slot="icon">
                <div class="w-full pl-3">
                  <span :class="textColorClass" class="text-zt-lg font-bold">{{ item.tipo_alias }}</span>
                  <div class="text-zt-dark-500 flex flex-wrap">
                    <div>
                      <zt-icon name="calendar" />
                      <span>
                        {{ $t('message.LicensesHistoryComponent.tabs.licenses.start') }}: {{ item.fecha_desde }}
                      </span>
                    </div>
                    <div>
                      <zt-icon name="calendar" />
                      <span>
                        {{ $t('message.LicensesHistoryComponent.tabs.licenses.return') }}: {{ item.fecha_regreso }}
                      </span>
                    </div>
                  </div>
                </div>
              </template>
              <div
                class="py-3 pr-3 m-auto"
                :class="setColorByStatus(item.estado_id)">
                {{ getStatus(item) }}
              </div>
              <div class="mr-3 px-2 m-auto text-zt-xl order-last font-extrabold">
                <zt-icon name="angle-right-solid" color="primary" />
              </div>
            </zt-list-item>
            <infinite-loading spinner="spiral" @infinite="showMore">
              <div class="noMoreResults" slot="no-more">{{ $t("message.LicensesHistoryComponent.tabs.licenses.noMoreResults") }}</div>
              <div class="noMoreResults" slot="no-results">{{ $t("message.LicensesHistoryComponent.tabs.licenses.noMoreResults") }}</div>
            </infinite-loading>
          </template>
          <template v-else>
            <div class="flex flex-col justify-center items-center pb-12 pt-16">
              <div class="h-40">
                <graphic-base height="100%" width="100%" :viewBox="'0 0 160 120'">
                  <EmptyStateSVG />
                </graphic-base>
              </div>
              <p :class="textColorClass" class="text-base leading-5 pt-4 font-normal">{{$t("message.LicensesHistoryComponent.tabs.licenses.emptyHistory")}}</p>
            </div>
          </template>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import InfiniteLoading from 'vue-infinite-loading';
import graphicBase from '@/components/commons/Illustrations/graphicBase'
import EmptyStateSVG from '@/components/commons/Illustrations/graphicSVG/graphicEmptyState'

export default {
  props: {
    loading: {
      type: Boolean,
      default: true
    },
    history: {
      default: [],
      type: Array
    },
    showTitle: {
      type: Boolean,
      default: true
    }
  },
  components: {
    InfiniteLoading,
    graphicBase,
    EmptyStateSVG
  },
  data() {
    return {
      userCanApproveLicenses: false,
    }
  },
  created() {
    for (let key in this.$store.getters.getActions) {
      if (this.$store.getters.getActions[key].id === "71") {
        this.userCanApproveLicenses = true;
        break;
      }
    }
  },
  computed: {
    isInIframe() {
      return window.self !== window.top
    },
    primaryLoadingColor() {
      return this.isInIframe ? '#2694fc' : '#4f41a3'
    },
    textColorClass() {
      return this.isInIframe ? 'text-iframe-primary' : 'text-zt-primary-200';
    },
    setColorByStatus(){
      return (statusId) => {
        if(statusId == 2 || statusId == 3 || statusId ==4){
          return 'text-zt-warning'
        }
        if(statusId == 5){
          return 'text-zt-success'
        }
        if(statusId == 10 || statusId == 9){
          return 'text-zt-dark-400'
        }
        if(statusId == 8){
          return 'text-zt-danger'
        }
      }
    }
  },
  methods: {
    showMore(event){
      this.$emit('get-history', event);
    },
    getStatus(item) {
      if(item.estado_id == 2 || item.estado_id == 3 || item.estado_id == 4){
        return this.$t("message.LicensesHistoryComponent.statusPending")
      }else if(item.estado_id == 9){
        return this.$t("message.LicensesHistoryComponent.statusExpired")
      }else{
        return item.estado_alias
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  ::v-deep .zt-listitem--item__link {
    div.w-full:nth-child(2){
      display: none;
    }
  }
  .text-iframe-primary {
    color: #2694fc !important;
  }
</style>
